iScreenWizard.factory('userService', function ($state, $rootScope, crypStorage, nieuwe360FeedbackService, p2cService, c2pService, nieuwGroepsprofielService, nieuweTestafnameService) {

    var service = {

        WIZARD_LEVEL_BASIC: 10,
        WIZARD_LEVEL_EXPERT: 50,

        WIZARD_MODULE_360_FEEDBACK: 51,
        WIZARD_MODULE_MATCHING: 52,
        WIZARD_MODULE_GROEPSPROFIELEN: 53,
        WIZARD_MODULE_TESTOTHEEK: 54,

        username: '',
        token: '',

        model: {
            id: 0,
            klantorganisatieId: 0,
            voornaam: '',
            achternaam: '',
            wizardNiveau: 0,
            wizardModules: [],
            loginExpires: 0,
            passwordExpired: 0,
            isSsoUser: false,
            isExpert: function () {
                return service.model.wizardNiveau == service.WIZARD_LEVEL_EXPERT;
            }
        },

        SaveState: function () {
            service.setUsername(service.username);
            service.setToken(service.token);
            localStorage.userService = angular.toJson(service.model);
        },

        RestoreState: function () {
            if (typeof localStorage.userService !== 'undefined') {
                service.model = angular.fromJson(localStorage.userService);
                service.username = service.getUsername();
                service.token = service.getToken();
            }
        }
    };

    service.isAuthenticated = function () {
        return service.model.loginExpires > Math.floor(Date.now() / 1000);
    };

    service.isPasswordExpired = function () {
        return service.model.passwordExpired === 1;
    }

    service.getUsername = function () {
        return crypStorage.get(ukey)
    };

    service.setUsername = function (username) {
        return crypStorage.set(ukey, username);
    };

    service.getToken = function () {
        return crypStorage.get(tkey)
    };

    service.setToken = function (token) {
        return crypStorage.set(tkey, token);
    };

    service.isExpert = function () {
        return service.isAuthenticated() && service.model.wizardNiveau == service.WIZARD_LEVEL_EXPERT;
    };

    service.canAccessModule = function (moduleNr) {
        return service.isExpert() && service.model.wizardModules.indexOf(moduleNr) > -1;
    };

    service.isSSOUser = function () {
        return service.model.isSsoUser;
    }

    service.logout = function () {
        service.token = '';
        service.model.loginExpires = 0;
        service.model.id = 0;
        service.model.klantorganisatieId = 0;
        service.SaveState();

        nieuweTestafnameService.model = {};
        nieuweTestafnameService.SaveState();
        nieuwe360FeedbackService.model = {};
        nieuwe360FeedbackService.SaveState();
        p2cService.model = {};
        p2cService.SaveState();
        c2pService.model = {};
        c2pService.SaveState();
        nieuwGroepsprofielService.model = {};
        nieuwGroepsprofielService.SaveState();

        //go to login
        $state.go('login');
    };

    $rootScope.$on("savestate", service.SaveState);
    $rootScope.$on("restorestate", service.RestoreState);

    service.RestoreState();

    return service;
});
